// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import './Login.css';  // Import CSS file for styling
import loginSider from './assets/images/sider.png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // from .env
  // const apiKey = process.env.REACT_APP_API_KEY;
  // const api = process.env.REACT_APP_API_URL;
  // from config.js
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username === '' || password === '') {
      setError('invalid input');
    } else {
      setError('');
      setInfo('');

      setLoading(true);

      try {      
        const response = await fetch(`${api}/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": `${apiKey}`,
          },
          body: JSON.stringify({ user: username, password } ),
        });
    
        if (response.ok) {
          const data = await response.json();
          setInfo('Login successful!');
          const token = data.token;
          // console.log(token);
          navigate("/message", { state: { token }});
        } else {
          // Handle login failure (optional)
          setError("Login failed. Please try again.");
        }
      } catch (err) {
        setError('network error')
      } finally {
        setLoading(false)
      }
    }
  };

  return (
    <div className="app-container">
      {/* Image section */}
      <div className="image-container">
        <img src={loginSider} alt="SiderImage" />
      </div>
      <div className="login-container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          {info && <p className="info-message">{info}</p>}
          
          <button type="submit" disabled={loading}>
            {loading ? (
              <div className="spinner"></div>
            ) : (
              'Login'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;